export var AuthDriver;
(function (AuthDriver) {
    AuthDriver["Default"] = "default";
    AuthDriver["Passport"] = "passport";
    AuthDriver["Sanctum"] = "sanctum";
})(AuthDriver || (AuthDriver = {}));
//# sourceMappingURL=authDriver.js.map